import { Box, Stack } from '@chakra-ui/react';
import { currentWallet } from '@cronos-app/wallet';
import { SilverSeparator } from '@ui/components/Atoms/Separator/SilverSeparator';
import VaultInfoRow from '@ui/components/Atoms/VaultInfoRow';
import { useWalletModal } from '@ui/components/Atoms/Wallet';
import WhiteButton from '@ui/components/Atoms/WhiteButton';
import useBaraHarvest from '@ui/hooks/contracts/BaraVault/useBaraHarvest';
import useBaraVaultUserInfo from '@ui/hooks/contracts/BaraVault/useBaraVaultUserInfo';
import useUserPendingReward from '@ui/hooks/contracts/BaraVault/useUserPendingReward';
import { captureVaultHarvest } from '@ui/utils/posthog/captureVaultActions';
import { useTranslations } from 'next-intl';

const VaultRewardInfoSection = () => {
  const t = useTranslations();

  const { data } = useBaraVaultUserInfo();
  const { isLoading, mutateAsync } = useBaraHarvest();
  const { data: pendingRewardData } = useUserPendingReward();
  const isConnected = currentWallet.useIsConnected();
  const openWalletModal = useWalletModal((s) => s.openModal);

  const handleHarvestButtonClick = async () => {
    await mutateAsync(undefined, {
      onSuccess: () => {
        if (!pendingRewardData) return;
        captureVaultHarvest(pendingRewardData);
      },
    });
  };

  if (!isConnected) {
    return (
      <WhiteButton onClick={openWalletModal}>
        {t('common.CONNECT WALLET')}
      </WhiteButton>
    );
  }

  return (
    <Stack
      w="full"
      gapX={{ base: 0, lg: 12 }}
      gapY={{ base: 2, lg: 0 }}
      direction={{ base: 'column', lg: 'row' }}
      separator={
        <SilverSeparator
          length={{ base: '100%', lg: '7em ' }}
          orientation={{ base: 'horizontal', lg: 'vertical' }}
        />
      }
    >
      <Box position="relative" flexGrow={1}>
        <VaultInfoRow
          label={t('common.Total Rewards Earned')}
          amount={data?.totalClaimed}
        />
      </Box>

      <Box flexGrow={1}>
        <VaultInfoRow
          label={t('common.Pending Rewards')}
          amount={pendingRewardData}
        />
        <WhiteButton
          mt="16px"
          width={{ base: 'full', lg: 'auto' }}
          fontSize={20}
          rounded="full"
          onClick={handleHarvestButtonClick}
          loading={isLoading}
          disabled={pendingRewardData?.isZero()}
          _disabled={{ opacity: 0.5 }}
        >
          {t('common.HARVEST ALL')}
        </WhiteButton>
      </Box>
    </Stack>
  );
};

export default VaultRewardInfoSection;
